"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactSwipeable = require("react-swipeable");
var _clsx = _interopRequireDefault(require("clsx"));
var _carousel = _interopRequireDefault(require("./carousel.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Carousel = function Carousel(props) {
  // console.log('Carousel props >> ', props)

  var NEXT = 'NEXT';
  var PREV = 'PREV';
  var indexTracking = (0, _react.useRef)(0);
  var centerOfScreenCords = (0, _react.useRef)({});
  var carouselContainerRef = (0, _react.useRef)();
  var carouselControlContainerRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(true),
    rightCarouselBtnVisibility = _useState[0],
    setRightCarouselBtnVisibility = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    leftCarouselBtnVisibility = _useState2[0],
    setLeftCarouselBtnVisibility = _useState2[1];
  var centerOfScreenRef = props.centerOfScreen;
  var carouselOfQuestionNo = props.qNo;
  var progressedQuestionNo = props.progressedQuestion;
  var currWindowWidth = props.windowWidth;
  var theme = props.theme;
  var answerSelectionStatus = props.answerSelectionStatus;
  var childrenMetadata = props.childrenMetadata;
  var _useState3 = (0, _react.useState)(false),
    stateUpdate = _useState3[0],
    setStateUpdate = _useState3[1];
  var _useState4 = (0, _react.useState)({}),
    carouselResetStatus = _useState4[0],
    setCarouselResetStatus = _useState4[1];
  var numItems = _react["default"].Children.count(props.children);
  // console.log('\n\nnumItems in Carousel >> ', numItems)

  var getInitialState = function getInitialState(numItems) {
    return {
      pos: 0,
      sliding: false,
      dir: NEXT
    };
  };
  var _useReducer = (0, _react.useReducer)(reducer, getInitialState(numItems)),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var getOrder = function getOrder(index, pos, numItems) {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
  };
  function reducer(state, action) {
    // console.log('into the reducer with state >> ', state, ' action >> ', action)
    switch (action.type) {
      case PREV:
        return _objectSpread(_objectSpread({}, state), {}, {
          dir: PREV,
          sliding: true,
          pos: state.pos === 0 ? 0 : state.pos - 1
        });
      case NEXT:
        return _objectSpread(_objectSpread({}, state), {}, {
          dir: NEXT,
          sliding: true,
          pos: state.pos === action.numItems - 1 ? state.pos : state.pos + 1
        });
      case 'stopSliding':
        return _objectSpread(_objectSpread({}, state), {}, {
          sliding: false
        });
      default:
        return state;
    }
  }
  var handlers = (0, _reactSwipeable.useSwipeable)({
    onSwipedLeft: function onSwipedLeft() {
      return slide(NEXT);
    },
    onSwipedRight: function onSwipedRight() {
      return slide(PREV);
    },
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true
  });
  var slide = function slide(dir) {
    dispatch({
      type: dir,
      numItems: numItems
    });
    setStateUpdate(function () {
      return true;
    });
    setTimeout(function () {
      dispatch({
        type: 'stopSliding'
      });
    }, 50);
  };
  (0, _react.useEffect)(function () {
    centerOfScreenCords.current = centerOfScreenRef.current && centerOfScreenRef.current.getBoundingClientRect();
    // console.log('centerOfScreenCords >> ', centerOfScreenCords.current)
    moveTransition();
  }, [state]);
  (0, _react.useEffect)(function () {
    if (state.pos !== 0) {
      // console.log('changing state.pos >> on chnage of progressedQuestionNo')
      state.pos = 0;
    }
    var carouselContainerChildren = carouselContainerRef.current && carouselContainerRef.current.children;
    if ("q" + carouselOfQuestionNo in answerSelectionStatus && answerSelectionStatus["q" + carouselOfQuestionNo].length) {
      var selectedAnswerIndex = childrenMetadata.findIndex(function (childObj) {
        return childObj.optionCode === answerSelectionStatus["q" + carouselOfQuestionNo][0].optionCode;
      });
      state.pos = selectedAnswerIndex !== -1 && selectedAnswerIndex;
    }
    // else {
    //   state.pos = parseInt(carouselContainerChildren.length/2)
    // }
    indexTracking.current = state.pos;
  }, [progressedQuestionNo, currWindowWidth, carouselContainerRef.current]);
  (0, _react.useEffect)(function () {
    if (progressedQuestionNo !== carouselOfQuestionNo) {
      setCarouselResetStatus(function (prevValue) {
        if ("q" + carouselOfQuestionNo in prevValue && 'front' in prevValue["q" + carouselOfQuestionNo]) {
          delete prevValue["q" + carouselOfQuestionNo].front;
        }
        return prevValue;
      });
    }
  }, [progressedQuestionNo, carouselOfQuestionNo]);
  var updateCarouselBtnVisibility = function updateCarouselBtnVisibility(carouselContainerChildren) {
    // console.log('checking carousel btn visibility >>>>>>')
    var checkingCarouselRightBtn = setTimeout(function () {
      setRightCarouselBtnVisibility(function () {
        var value = carouselContainerChildren[carouselContainerChildren.length - 1].getBoundingClientRect().right > currWindowWidth;
        // console.log('rightCarouselBtnVisibility.current >> ', value)
        return value;
      });
      clearTimeout(checkingCarouselRightBtn);
    }, 1000);
    var checkingCarouselLeftBtn = setTimeout(function () {
      setLeftCarouselBtnVisibility(function () {
        var value = carouselContainerChildren[0].getBoundingClientRect().left < 0;
        // console.log('leftCarouselBtnVisibility.current >> ', value)
        return value;
      });
      clearTimeout(checkingCarouselLeftBtn);
    }, 1000);
  };
  var moveTransition = function moveTransition() {
    // console.log('state >> ', state)
    var carouselContainerChildren = carouselContainerRef.current && carouselContainerRef.current.children;
    if (!state.sliding) {
      if (currWindowWidth > 767) {
        indexTracking.current = state.pos;
      }
      if (state.dir === NEXT) {
        if (indexTracking.current > 0 && carouselContainerChildren && carouselContainerChildren.length) {
          var childCords = carouselContainerChildren[indexTracking.current].getBoundingClientRect();
          var currTransformStyle = carouselContainerRef.current.style.transform.match(/-*(\d+\.*\d*)/);
          var currCarouselPos = currTransformStyle && currTransformStyle[0];
          var diffFromCenter = childCords.x - centerOfScreenCords.current.x + childCords.width / 2;
          var movePx = currCarouselPos - diffFromCenter;
          carouselContainerRef.current.style.transform = "translateX(calc(" + movePx + "px))";
          updateCarouselBtnVisibility(carouselContainerChildren);
          return;
        } else {
          // console.log('progressedQuestionNo in moveTransition >> ', progressedQuestionNo)
          // console.log('carouselResetStatus in moveTransition >> ', carouselResetStatus[`q${carouselOfQuestionNo}`])
          if (progressedQuestionNo > 0 && carouselResetStatus["q" + carouselOfQuestionNo]) {
            var _childCords = carouselContainerChildren[indexTracking.current].getBoundingClientRect();
            carouselContainerRef.current.style.transform = "translateX(calc(" + (centerOfScreenCords.current.x - _childCords.x - _childCords.width / 2) + "px))";
          }
          return;
        }
      }
      if (state.dir === PREV) {
        // console.log('PREV indexTracking.current >> ', indexTracking.current)
        if (carouselContainerChildren && carouselContainerChildren.length && indexTracking.current >= 0) {
          var _childCords2 = carouselContainerChildren[indexTracking.current].getBoundingClientRect();
          var _currTransformStyle = carouselContainerRef.current.style.transform.match(/-*(\d+\.*\d*)/);
          var _currCarouselPos = _currTransformStyle && _currTransformStyle[0];
          var _diffFromCenter = centerOfScreenCords.current.x - (_childCords2.x + _childCords2.width / 2);
          var _movePx = Number(_currCarouselPos) + _diffFromCenter;
          carouselContainerRef.current.style.transform = "translateX(calc(" + _movePx + "px))";
          updateCarouselBtnVisibility(carouselContainerChildren);
          return;
        }
      }
      ;
    }
    ;
  };
  var setInitialCarousalPosition = function setInitialCarousalPosition() {
    var carouselContainerChildren = carouselContainerRef.current && carouselContainerRef.current.children;
    if (carouselContainerRef.current) {
      carouselContainerRef.current.style.transitionDelay = '1510ms';
      Array.from(carouselContainerChildren).map(function (child) {
        return child.style.transitionDelay = '1.8s';
      });
    }
    if (carouselContainerChildren && carouselContainerChildren.length && !("q" + carouselOfQuestionNo in carouselResetStatus)) {
      var lastChildCords = carouselContainerChildren[carouselContainerChildren.length - 1].getBoundingClientRect();
      setCarouselResetStatus(function () {
        var _objectSpread2;
        return _objectSpread(_objectSpread({}, carouselResetStatus), (_objectSpread2 = {}, _objectSpread2["q" + carouselOfQuestionNo] = _objectSpread(_objectSpread({}, carouselResetStatus["q" + carouselOfQuestionNo]), {
          'back': centerOfScreenCords.current.x - lastChildCords.right
        }), _objectSpread2));
      });
      return "translateX(calc(" + (centerOfScreenCords.current.x - lastChildCords.right) + "px))";
    } else if (carouselResetStatus["q" + carouselOfQuestionNo] && carouselResetStatus["q" + carouselOfQuestionNo].back) {
      return "translateX(calc(" + (carouselResetStatus["q" + carouselOfQuestionNo] && carouselResetStatus["q" + carouselOfQuestionNo].back) + "px))";
    } else if (!carouselContainerChildren) {
      setTimeout(function () {
        var carouselContainerChildren = carouselContainerRef.current && carouselContainerRef.current.children;
        if (carouselContainerChildren && carouselContainerChildren.length && !("q" + carouselOfQuestionNo in carouselResetStatus)) {
          var _lastChildCords = carouselContainerChildren[carouselContainerChildren.length - 1].getBoundingClientRect();
          setCarouselResetStatus(function () {
            var _objectSpread3;
            return _objectSpread(_objectSpread({}, carouselResetStatus), (_objectSpread3 = {}, _objectSpread3["q" + carouselOfQuestionNo] = _objectSpread(_objectSpread({}, carouselResetStatus["q" + carouselOfQuestionNo]), {
              'back': centerOfScreenCords.current.x - _lastChildCords.right
            }), _objectSpread3));
          });
          return "translateX(calc(" + (centerOfScreenCords.current.x - _lastChildCords.right) + "px))";
        } else {
          return "translateX(calc(" + (carouselResetStatus["q" + carouselOfQuestionNo] && carouselResetStatus["q" + carouselOfQuestionNo].back) + "px))";
        }
      }, 0);
    }
  };
  var resetCarouselStatus = function resetCarouselStatus() {
    var carouselContainerChildren = carouselContainerRef.current && carouselContainerRef.current.children;
    if (carouselContainerRef.current && carouselContainerRef.current.style.transitionDelay === '1510ms') {
      var removeTransitionDelay = setTimeout(function () {
        carouselContainerRef.current.style.transitionDelay = '0ms';
        setTimeout(function () {
          carouselControlContainerRef.current.style.display = carouselControlVisibility() && 'flex';
        }, 1000);
        if (currWindowWidth < 768) {
          setTimeout(function () {
            Array.from(carouselContainerChildren).map(function (child) {
              return child.style.transitionDelay = '0ms';
            });
          }, 1800);
        }
        clearTimeout(removeTransitionDelay);
      }, 1510);
    }
    if (currWindowWidth < 768) {
      var selectedAnswerIndex = -1;
      if ("q" + carouselOfQuestionNo in answerSelectionStatus && answerSelectionStatus["q" + carouselOfQuestionNo].length) {
        selectedAnswerIndex = childrenMetadata.findIndex(function (childObj) {
          return childObj.optionCode === answerSelectionStatus["q" + carouselOfQuestionNo][0].optionCode;
        });
      }
      if (carouselOfQuestionNo === 1 && indexTracking.current !== selectedAnswerIndex) {
        if (selectedAnswerIndex !== -1) {
          indexTracking.current = selectedAnswerIndex;
        }
        // else {
        //   indexTracking.current = parseInt(carouselContainerChildren.length/2)
        // }
      }
      var childCords = carouselContainerChildren[indexTracking.current].getBoundingClientRect();
      var currTransformStyle = carouselContainerRef.current.style.transform.match(/-*(\d+\.*\d*)/);
      var currCarouselPos = currTransformStyle && currTransformStyle[0];
      var diffFromCenter = centerOfScreenCords.current.x - (childCords.x - (100 + 50 * indexTracking.current)) - childCords.width / 2;
      var movePx = Number(currCarouselPos) + diffFromCenter;
      if (currCarouselPos && !carouselResetStatus["q" + carouselOfQuestionNo].front) {
        setCarouselResetStatus(function () {
          var _objectSpread4;
          return _objectSpread(_objectSpread({}, carouselResetStatus), (_objectSpread4 = {}, _objectSpread4["q" + carouselOfQuestionNo] = _objectSpread(_objectSpread({}, carouselResetStatus["q" + carouselOfQuestionNo]), {
            'front': movePx
          }), _objectSpread4));
        });
        return "translateX(calc(" + movePx + "px))";
      } else {
        return "translateX(calc(" + (carouselResetStatus["q" + carouselOfQuestionNo] && carouselResetStatus["q" + carouselOfQuestionNo].front) + "px))";
      }
    } else {
      if (!stateUpdate) {
        if ("q" + carouselOfQuestionNo in answerSelectionStatus && answerSelectionStatus["q" + carouselOfQuestionNo].length) {
          var _selectedAnswerIndex = childrenMetadata.findIndex(function (childObj) {
            return childObj.optionCode === answerSelectionStatus["q" + carouselOfQuestionNo][0].optionCode;
          });
          state.pos = _selectedAnswerIndex !== -1 && _selectedAnswerIndex;
        } else {
          // state.pos = parseInt(carouselContainerChildren.length/2)
          state.pos = 0;
        }
        indexTracking.current = state.pos;
      }
      return "translateX(calc(0px))";
    }
  };
  var centerZoom = function centerZoom(index) {
    if (state.pos === index) {
      indexTracking.current = index;
      if (carouselResetStatus["q" + carouselOfQuestionNo] && carouselResetStatus["q" + carouselOfQuestionNo].front) {
        return 'scale3d(1.1, 1.2, 1)';
      }
    }
    return '';
  };
  var carouselControlVisibility = function carouselControlVisibility() {
    if (carouselContainerRef && carouselContainerRef.current) {
      var carouselChildrenWidth = Array.from(carouselContainerRef.current.children).reduce(function (acc, curr) {
        return typeof acc === 'number' ? acc + curr.getBoundingClientRect().width : acc.getBoundingClientRect().width + curr.getBoundingClientRect().width;
      });
      if (carouselChildrenWidth > currWindowWidth && currWindowWidth > 767) {
        return true;
      } else {
        return false;
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, handlers, {
    style: {
      transition: 'visibility 0.1s linear 1500ms',
      visibility: progressedQuestionNo !== carouselOfQuestionNo ? 'hidden' : 'visible'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      overflow: 'hidden',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: carouselContainerRef,
    id: "CarouselContainer",
    style: {
      transition: state.sliding ? "none" : "transform 0.5s cubic-bezier(0.45, 0.17, 0.58, 1)",
      transform: carouselOfQuestionNo !== progressedQuestionNo ? setInitialCarousalPosition() : resetCarouselStatus()
    },
    className: (0, _clsx["default"])(_carousel["default"].carouselContainer)
  }, _react["default"].Children.map(props.children, function (child, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        transform: carouselOfQuestionNo === progressedQuestionNo ? "translateX(0px) " + (currWindowWidth < 768 ? centerZoom(index) : '') : "translateX(" + (100 + 50 * index) + "px)",
        transition: "transform 0.5s ease-in-out"
      },
      className: (0, _clsx["default"])(_carousel["default"].carouselChildContainer)
    }, /*#__PURE__*/_react["default"].cloneElement(child, {
      centered: currWindowWidth < 768 ? Boolean(centerZoom(index)) : ''
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: carouselControlContainerRef,
    style: {
      display: 'none',
      justifyContent: 'space-between',
      position: 'absolute',
      width: '100%',
      top: '50%'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      slide(PREV);
    },
    className: (0, _clsx["default"])(_carousel["default"].slideBtn),
    style: {
      visibility: leftCarouselBtnVisibility ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx["default"])(_carousel["default"].icon, theme.mmcIconChevronLeft, _carousel["default"].line_height_0)
  })), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return slide(NEXT);
    },
    className: (0, _clsx["default"])(_carousel["default"].slideBtn),
    style: {
      visibility: rightCarouselBtnVisibility ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: (0, _clsx["default"])(_carousel["default"].icon, theme.mmcIconChevronRight, _carousel["default"].line_height_0)
  })))));
};
var _default = Carousel;
exports["default"] = _default;